/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EvaluationType } from './EvaluationType';
import {
    EvaluationTypeFromJSON,
    EvaluationTypeFromJSONTyped,
    EvaluationTypeToJSON,
} from './EvaluationType';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { QuantityValueType } from './QuantityValueType';
import {
    QuantityValueTypeFromJSON,
    QuantityValueTypeFromJSONTyped,
    QuantityValueTypeToJSON,
} from './QuantityValueType';

/**
 * 
 * @export
 * @interface FaultyNumericValueDto
 */
export interface FaultyNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof FaultyNumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {QuantityValueType}
     * @memberof FaultyNumericValueDto
     */
    valueType?: QuantityValueType;
    /**
     * 
     * @type {EvaluationType}
     * @memberof FaultyNumericValueDto
     */
    evaluationType?: EvaluationType;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {GeometryLabelDto}
     * @memberof FaultyNumericValueDto
     */
    geometry?: GeometryLabelDto;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    min?: number | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof FaultyNumericValueDto
     */
    fault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    $type?: FaultyNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const FaultyNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoFaultyNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type FaultyNumericValueDtoTypeEnum = typeof FaultyNumericValueDtoTypeEnum[keyof typeof FaultyNumericValueDtoTypeEnum];


/**
 * Check if a given object implements the FaultyNumericValueDto interface.
 */
export function instanceOfFaultyNumericValueDto(value?: unknown): value is FaultyNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(FaultyNumericValueDtoTypeEnum)[0];
}

export function FaultyNumericValueDtoFromJSON(json: any): FaultyNumericValueDto {
    return FaultyNumericValueDtoFromJSONTyped(json, false);
}

export function FaultyNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaultyNumericValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'defaultValue': !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        'valueType': !exists(json, 'valueType') ? undefined : QuantityValueTypeFromJSON(json['valueType']),
        'evaluationType': !exists(json, 'evaluationType') ? undefined : EvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'geometry': !exists(json, 'geometry') ? undefined : GeometryLabelDtoFromJSON(json['geometry']),
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'fault': !exists(json, 'fault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['fault']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function FaultyNumericValueDtoToJSON(value?: FaultyNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'value': value.value,
        'numericId': value.numericId,
        'defaultValue': value.defaultValue,
        'unitAbbreviation': value.unitAbbreviation,
        'valueType': QuantityValueTypeToJSON(value.valueType),
        'evaluationType': EvaluationTypeToJSON(value.evaluationType),
        'decimalPlaces': value.decimalPlaces,
        'geometry': GeometryLabelDtoToJSON(value.geometry),
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        'max': value.max,
        'min': value.min,
        'fault': AnalysisResultDtoAirPressureFaultToJSON(value.fault),
        '$type': value.$type,
    });
}

